import * as Yup from 'yup';

/** Custom Imports */
import t from '../../application/translate';

const contactFormSchema = () => Yup.object().shape({
  emailSender: Yup.string()
    .email(t('contactForm/emailSender/error/format'))
    .required(t('contactForm/emailSender/error/default')),
  emailMessage: Yup.string()
    .required(t('contactForm/emailMessage/error/default')),
});

export default contactFormSchema;



// WEBPACK FOOTER //
// ./src/components/ContactForm/contactFormSchema.js